export type { ShopifyPeriod } from "@/lib/date-utils"
import type { ShopifyPeriod } from "@/lib/date-utils"
import { createTranslator, type useTranslations } from "next-intl"
import englishMessages from "@/translations/en/shopify-periods.json"

const englishTranslator = createTranslator({ locale: "en", messages: englishMessages, namespace: "ShopifyPeriods" })


export const DEFAULT_SHOPIFY_PERIOD: ShopifyPeriod = "this_month"

export const SHOPIFY_PERIOD_OPTIONS = getSHOPIFY_PERIOD_OPTIONS()

export function getSHOPIFY_PERIOD_OPTIONS(t: ReturnType<typeof useTranslations<"ShopifyPeriods">> = englishTranslator): { value: ShopifyPeriod; label: string }[] {
  return [
  { value: "today", label: t("today") },
  { value: "7d", label: t("last7Days") },
  { value: "this_month", label: t("thisMonth") },
  { value: "last_month", label: t("lastMonth") },
  { value: "3m", label: t("last3Months") },
  { value: "custom", label: t("customRange") },
]
}

/** Maximum history period in years for the custom date picker. */
export const MAX_SHOPIFY_HISTORY_YEARS = 2

// ---------------------------------------------------------------------------
// Comparison mode
// ---------------------------------------------------------------------------

export type ComparisonMode = "previous_period" | "same_period_last_year" | "custom" | "none"

export const DEFAULT_COMPARISON_MODE: ComparisonMode = "previous_period"

export const COMPARISON_MODE_OPTIONS = getCOMPARISON_MODE_OPTIONS()

export function getCOMPARISON_MODE_OPTIONS(t: ReturnType<typeof useTranslations<"ShopifyPeriods">> = englishTranslator): { value: ComparisonMode; label: string }[] {
  return [
  { value: "previous_period", label: t("previousPeriod") },
  { value: "same_period_last_year", label: t("samePeriodLastYear") },
  { value: "custom", label: t("customRange2") },
  { value: "none", label: t("none") },
]
}
